<template>
  <div class="verify-wrap">
    <div class="head">
      <div class="back" @click="back"></div>
      {{ $t('input_code') }}
    </div>
    <div class="tips">
      {{ $t('send', { 0: query.bind_type === BIND_TYPES.EMAIL ? query.email : `+${query.csc} ${query.mobile}` }) }}
      <template v-if="count > 0">
        <span>{{ `${count}s` }}</span>
      </template>
      <template v-else>
        <span class="try-again" @click="reSend()">{{ $t('send_again') }}</span>
      </template>
    </div>
    <div class="code-wrap">
      <Code :code="code" v-model="isFinish" @complete="completeCode"></Code>
    </div>
    <div class="btns">
      <Button type="warning" :disabled="!isFinish" @click="login()">{{ $t('login') }} </Button>
    </div>
  </div>
</template>

<script>
import Code from './Code.vue'
import { sendCode, login } from '../api'
import { VerifySM } from '../utils/SMCaptcha'
import { bindAccount } from '../utils/Qtbridge'
import { mapMutations } from 'vuex'
export default {
  name: 'Verify',
  components: { Code },
  data () {
    return {
      BIND_TYPES: {
        MOBILE: 101,
        EMAIL: 102
      },
      isFinish: false,
      code: '',
      count: 0,
      timer: null,
      userInfo: {},
      query: this.$route.query,
      routerParams: {
        from: this.$route.query.from,
        loginType: this.$route.query.loginType
      },
      loading: false
    }
  },
  created () {
    this.startCutDown()
  },
  methods: {
    ...mapMutations({
      setBindInfoItem: 'setBindInfoItem'
    }),
    startCutDown () {
      if (this.query.bind_type) {
        this.count = 60
        this.timer = setInterval(() => {
          if (this.count === 0) {
            clearInterval(this.timer)
            this.timer = null
          }
          this.count -= 1
        }, 1000);
      }
    },
    completeCode (code) {
      this.code = code.join('')
    },
    login (verifyData) {
      if (this.loading) return
      // 微端绑定时，点击一次后再点击，直接调用微端绑定逻辑
      if (this.userInfo.id && this.routerParams.from === 'bind') {
        this.goResult()
      }
      const params = {
        ...this.query,
        bind_type: Number(this.query.bind_type),
        code_type: Number(this.query.code_type),
        code: this.code
      }
      if (verifyData) {
        params.verify_data = verifyData
        params.captcha_channel = 'sm'
      }
      if (Number(this.query.bind_type) === this.BIND_TYPES.EMAIL) {
        this.$utils.log('pc_login_action', {
          login_action: 'click_email_land'
        })
      } else {
        this.$utils.log('pc_login_action', {
          login_action: 'click_mobile_land'
        })
      }
      this.loading = true
      login(params).then((res) => {
        delete params.verify_data
        delete params.captcha_channel
        this.userInfo = {
          id: res.fp_uid,
          name: res.bind_display_name || res.user_display_name,
          token: res.session_key,
          type: this.$ENUM.SOCIAL_MAP.FUNPLUS_ID,
          expire: res.session_key_timeout,
          mode: Number(this.query.bind_type) === this.BIND_TYPES.EMAIL ? 'email' : 'mobile'
        }
        this.goResult()
      }).catch(err => {
        if (err.code === 110011) {
          VerifySM(data => {
            if (data.pass) {
              this.login(data)
            }
          })
        } else {
          this.$msg.success(err.msg)
        }
      }).finally(() => { this.loading = false })
    },
    goResult () {
      if (this.routerParams.from === 'bind') {
        bindAccount(this.userInfo)
          .then(res => {
            if (res.code !== 0) this.$msg.success(res.msg || this.$t('web_bind_fail'))
            this.$msg.success(this.$t('web_bind_ok'))
            this.setBindInfoItem({
              key: 'funplus_id',
              value: {
                name: this.userInfo.name
              }
            })
            this.$router.push({
              name: 'Account2'
            })
          })
          .catch(err => {
            this.$msg.success(this.$t(`KGSDK_${err.code}`))
          })
      } else {
        this.$router.push({
          name: 'Result2',
          params: {
            type: 'success',
            loginData: this.userInfo
          }
        })
      }
    },
    reSend (verifyData) {
      const params = { ...this.query }
      if (verifyData) {
        params.verify_data = verifyData
        params.captcha_channel = 'sm'
      }
      sendCode(params).then(() => {
        window.localStorage.setItem('sendTime', Math.floor(new Date().getTime() / 1000))
        delete params.verify_data
        delete params.captcha_channel
        this.startCutDown()
        this.$msg.success(this.$t('send_success'))
      }).catch(err => {
        if (err.code === 110011) {
          VerifySM(data => {
            if (data.pass) {
              this.reSend(data)
            }
          })
        } else {
          this.$msg.success(err.msg)
        }
      })
    },
    back () {
      this.$router.back()
    }
  },
  beforeDestroy () {
    clearInterval(this.timer)
    this.timer = null
  }
}
</script>

<style lang='less' scoped >
.verify-wrap {
  width: 100%;
  height: 100%;
  padding: 0 30px 20px;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: center;
  .head {
    position: relative;
    margin: 0 -30px;
    width: calc(100% + 60px);
    text-align: center;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    padding: 15px 45px 0;
    font-size: 18px;
    font-weight: 600;
    color: #001111;
    line-height: 1.5;
    .back {
      position: fixed;
      width: 16px;
      height: 14px;
      background: url(~@img/icon_back.png) center center no-repeat;
      background-size: 100% 100%;
      top: 20px;
      left: 16px;
      cursor: pointer;
    }
  }
  .tips {
    text-align: center;
    margin: 0 -20px;
    height: 14px;
    font-size: 14px;
    font-weight: 400;
    color: #999999;
    line-height: 19px;
    margin-top: 8px;
    .try-again {
      color: #FE6918;
      text-decoration: underline;
      cursor: pointer;
    }
  }
  .code-wrap {
    flex-grow: 1;
    display: flex;
    align-items: center;
  }
}
</style>
